// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H14.7964C12.5643 22.0463 11 19.8308 11 17.25C11 13.7982 13.7982 11 17.25 11C18.657 11 19.9554 11.4649 21 12.2495V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M17.25 14.5C15.7312 14.5 14.5 15.7312 14.5 17.25C14.5 18.7688 15.7312 20 17.25 20C18.7688 20 20 18.7688 20 17.25C20 15.7312 18.7688 14.5 17.25 14.5ZM12.5 17.25C12.5 14.6266 14.6266 12.5 17.25 12.5C19.8734 12.5 22 14.6266 22 17.25C22 18.2002 21.721 19.0852 21.2405 19.8276L22.9142 21.499L21.501 22.9142L19.826 21.2415C19.0839 21.7214 18.1995 22 17.25 22C14.6266 22 12.5 19.8734 12.5 17.25Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-search-filled')
export default class FileSearchFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-search-filled',
    }
  }
}
